import getAttachment from '../selectors/getAttachment';
import AttachmentModel from '../store/schema/AttachmentModel';
import { ClientAttachmentId } from 'owa-client-ids';
import { action } from 'satcheljs/lib/legacy';

export default action('setPreviewImageUrl')(function setPreviewImageUrl(
    attachmentId: ClientAttachmentId,
    previewImageUrl: string
) {
    const attachment: AttachmentModel = getAttachment(attachmentId);
    attachment.previewImage.url = previewImageUrl;
});
